module.exports = __webpack_public_path__ + "img/13.05b53775.png";